/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_TaglineInputs */

const en_site_tagline = /** @type {(inputs: Site_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the right AI for every job`)
};

const zh_site_tagline = /** @type {(inputs: Site_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找到每个任务对的 AI 工具`)
};

/**
* | output |
* | --- |
* | "Find the right AI for every job" |
*
* @param {Site_TaglineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const site_tagline = /** @type {((inputs?: Site_TaglineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_TaglineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_site_tagline(inputs)
	return zh_site_tagline(inputs)
});
export { site_tagline as "site.tagline" }